"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _constants = require("../constants"),
    OUTPUT_STATUS = {
  INTERNAL_REVIEW: "INTERNAL_REVIEW",
  PENDING_REVIEW: "PENDING_REVIEW",
  COST_REVIEW: "COST_REVIEW"
},
    getChangesModalConstants = function getChangesModalConstants(a) {
  return a === OUTPUT_STATUS.INTERNAL_REVIEW ? {
    title: "Reject Version",
    subtitle: "Reason for rejection",
    additionalReasonTitle: "Additional Comments",
    reasons: _constants.REJECTION_REASONS.REJECT_VERSION,
    allowOther: !1
  } : {
    title: "Submit Changes",
    subtitle: "Tell us why",
    additionalReasonTitle: "Reason",
    reasons: _constants.REJECTION_REASONS.SUBMIT_CHANGES,
    allowOther: !0
  };
},
    _default = getChangesModalConstants;

exports["default"] = _default;